export default "/assets/images/CC-mila-with-box.5af0286daa09df05.png";